import { createUseStyles } from 'react-jss';
import { IQuestionConfig } from '../core/IQuestion';
import { IGenericQuestionProvider, IQuestionViewProps } from '../core/question-provider/IQuestionProvider';
import { MiniWizardViewModel } from '../core/MiniWizardViewModel';
import { Step } from '../../Step';
import { IonButton } from '@ionic/react';

const questionType = 'yes-no' as const;
type IYesNo = typeof questionType;

interface IYesNoQuestionConfig {
    labels?: {
        yes: string;
        no: string;
    }
};

export type IYesNoQuestion = IQuestionConfig<IYesNo, boolean,  IYesNoQuestionConfig>;

export class YesNoQuestionProvider implements IGenericQuestionProvider<IYesNoQuestion> {
    questionType = questionType;

    validate = (question: IYesNoQuestion) => typeof question.answer === 'boolean';

    render = (question: IYesNoQuestion, wizard: MiniWizardViewModel) => {
        return <YesOrNoStepV2 question={question} wizard={wizard} />;
    };
}

const useStyles = createUseStyles({
    buttons: {
        display: 'flex',
        alignItems: 'center',

        '& > ion-button': {
            width: 120,
            marginLeft: 20
        }
    }
});

export const YesOrNoStepV2: React.FC<IQuestionViewProps<IYesNoQuestion>> = ({ question, wizard }) => {
    const classes = useStyles();

    return (
        <Step question={question.questionTitle} subTitle={question.subTitle}>
            <div className={classes.buttons}>
                <IonButton
                    data-id="yes"
                    fill={question.answer === true ? 'solid': 'outline'}
                    onClick={() => wizard.answer(true)}
                >
                    {question.labels?.yes || 'Yes'}
                </IonButton>
                <IonButton
                    data-id="no"
                    fill={question.answer === false ? 'solid': 'outline'}
                    onClick={() => wizard.answer(false)}
                >
                    {question.labels?.no || 'No'}
                </IonButton>
            </div>
        </Step>
    );
};
